import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export abstract class IFeaturesService  {
    abstract isFeatureEnabled(feature:string):Observable<boolean>;
    abstract getEnabledFeatures():Observable<string[]>;
}